var _path, _path2, _path3, _path4, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgYoutube(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 30,
    viewBox: "0 0 34 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4565_214949)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.2823 3.27783H7.72895C6.37738 3.27783 5.28345 4.37177 5.28345 5.72333V24.2727C5.28345 25.6242 6.37738 26.7182 7.72895 26.7182H14.1697L17.4475 29.996L20.7254 26.7182H26.2783C27.6299 26.7182 28.7238 25.6242 28.7238 24.2727V5.72333C28.7238 4.37177 27.6299 3.27783 26.2783 3.27783H26.2823Z",
    fill: "url(#paint0_linear_4565_214949)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M32.0057 6.29019V4.8435C32.0057 2.16811 29.8376 -0.00390625 27.1583 -0.00390625H6.8491C4.17372 5.72852e-05 2.00566 2.16811 2.00566 4.84746V6.29415C1.0346 6.53196 0.313232 7.39998 0.313232 8.44239V21.5657C0.313232 22.6081 1.0346 23.4761 2.00566 23.7139V25.1606C2.00566 27.836 4.17372 30.008 6.85307 30.008H12.9807C13.1749 30.008 13.3493 29.9485 13.488 29.8494C13.9042 29.5561 14.0191 28.918 13.603 28.5018C13.5514 28.4503 13.496 28.4067 13.4365 28.371C13.3017 28.2878 13.1432 28.2442 12.9807 28.2442H6.85307C5.14875 28.2442 3.76944 26.8649 3.76944 25.1606V4.84746C3.76944 3.14314 5.14875 1.76383 6.85307 1.76383H27.1622C28.8665 1.76383 30.2458 3.14314 30.2458 4.84746V25.1566C30.2458 26.8609 28.8665 28.2402 27.1622 28.2402H21.9185C21.7837 28.2402 21.6529 28.272 21.534 28.3274C21.4468 28.371 21.3636 28.4265 21.2922 28.4979C20.9791 28.811 20.9672 29.247 21.1575 29.568C21.3041 29.8177 21.5736 30.0001 21.9145 30.0001H27.1583C29.8336 30.0001 32.0057 27.832 32.0057 25.1527V23.706C32.9767 23.4682 33.6981 22.6001 33.6981 21.5577V8.43843C33.6981 7.39601 32.9767 6.528 32.0057 6.29019Z",
    fill: "url(#paint1_linear_4565_214949)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M25.01 7.94292H9.00125C8.79514 7.94292 8.60093 7.88743 8.43843 7.79231C8.09756 7.5981 7.86768 7.22949 7.86768 6.80935C7.86768 6.53191 7.96676 6.27824 8.13323 6.08006C8.33934 5.83432 8.65246 5.67578 9.00125 5.67578H25.006C25.3191 5.67578 25.6005 5.80261 25.8066 6.00872C26.0127 6.21482 26.1396 6.49623 26.1396 6.80935C26.1396 7.03924 26.0722 7.2493 25.9572 7.42766C25.7551 7.73682 25.4063 7.94292 25.01 7.94292Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5,
    d: "M26.2823 3.27783H7.72901C6.37744 3.27783 5.28351 4.37177 5.28351 5.72333V24.2727C5.28351 25.6242 6.37744 26.7182 7.72901 26.7182H14.1698L17.4476 29.996L20.7254 26.7182H26.2784C27.6299 26.7182 28.7239 25.6242 28.7239 24.2727V5.72333C28.7239 4.37177 27.6299 3.27783 26.2784 3.27783H26.2823ZM27.5546 24.2766C27.5546 24.9782 26.9839 25.5489 26.2823 25.5489H20.2419L17.4476 28.3432L14.6533 25.5489H7.72901C7.02746 25.5489 6.45671 24.9782 6.45671 24.2766V5.72333C6.45671 5.02179 7.02746 4.45104 7.72901 4.45104H26.2784C26.9799 4.45104 27.5506 5.02179 27.5506 5.72333V24.2727L27.5546 24.2766ZM13.603 28.4978C14.0191 28.914 13.9002 29.5521 13.488 29.8454C13.3493 29.9445 13.1789 30.0039 12.9807 30.0039H6.85307C4.17768 30.0039 2.00566 27.8359 2.00566 25.1565V23.7099C1.0346 23.472 0.313232 22.604 0.313232 21.5616V14.8593C1.40717 15.3508 2.56056 15.7986 3.76547 16.191V25.1565C3.76547 26.8609 5.14478 28.2402 6.8491 28.2402H12.9767C13.1392 28.2402 13.2978 28.2838 13.4325 28.367C13.492 28.4027 13.5475 28.4463 13.599 28.4978H13.603ZM30.2458 16.191V25.1565C30.2458 26.8609 28.8665 28.2402 27.1622 28.2402H21.9185C21.7837 28.2402 21.6529 28.2719 21.534 28.3274C21.4468 28.371 21.3636 28.4265 21.2922 28.4978C20.9791 28.8109 20.9672 29.2469 21.1575 29.568C21.3041 29.8177 21.5736 30 21.9145 30H27.1583C29.8336 30 32.0057 27.8319 32.0057 25.1526V23.7059C32.9767 23.4681 33.6981 22.6001 33.6981 21.5577V14.8553C32.6042 15.3468 31.4508 15.7947 30.2458 16.1871V16.191Z",
    fill: "url(#paint2_linear_4565_214949)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5,
    d: "M17.0037 18.2047C12.8182 18.2047 8.84672 17.6419 5.27954 16.6431V24.2729C5.27954 25.6244 6.37348 26.7184 7.72504 26.7184H14.1658L17.4436 29.9962L20.7215 26.7184H26.2744C27.626 26.7184 28.7199 25.6244 28.7199 24.2729V16.6431C25.1527 17.6419 21.1852 18.2047 16.9958 18.2047H17.0037Z",
    fill: "url(#paint3_linear_4565_214949)"
  }), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M22.513 12.6555C22.513 12.6555 22.406 11.847 22.0691 11.4942C21.6411 11.0265 21.1615 11.0265 20.9435 10.9988C19.37 10.8799 17.0117 10.8799 17.0117 10.8799H17.0077C17.0077 10.8799 14.6494 10.8799 13.0759 10.9988C12.8539 11.0265 12.3783 11.0305 11.9502 11.4942C11.6133 11.8509 11.5023 12.6595 11.5023 12.6595C11.5023 12.6595 11.3914 13.6068 11.3914 14.558V15.4459C11.3914 16.3971 11.5023 17.3444 11.5023 17.3444C11.5023 17.3444 11.6133 18.153 11.9502 18.5097C12.3783 18.9774 12.9411 18.9615 13.1908 19.0091C14.0905 19.1003 17.0117 19.128 17.0117 19.128C17.0117 19.128 19.3739 19.124 20.9474 19.0051C21.1694 18.9774 21.645 18.9734 22.0731 18.5097C22.41 18.153 22.517 17.3444 22.517 17.3444C22.517 17.3444 22.628 16.3971 22.628 15.4459V14.558C22.628 13.6068 22.517 12.6595 22.517 12.6595L22.513 12.6555ZM18.8824 14.8791L15.8464 16.52V13.9952V13.2263L17.2138 13.9714L18.8824 14.8791Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4565_214949",
    x1: 5.28345,
    y1: 16.6389,
    x2: 28.7278,
    y2: 16.6389,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B50627"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F93D3D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_4565_214949",
    x1: 0.313232,
    y1: 14.9981,
    x2: 33.6981,
    y2: 14.9981,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B50627"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F93D3D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_4565_214949",
    x1: 0.313232,
    y1: -0.0000123407,
    x2: 33.6981,
    y2: -0.0000123407,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B50627"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F93D3D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_4565_214949",
    x1: 0.313232,
    y1: 23.3216,
    x2: 0.709585,
    y2: 23.3216,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B50627"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F93D3D"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4565_214949"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 33.3849,
    height: 30,
    fill: "white",
    transform: "translate(0.313232)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutube);
export default __webpack_public_path__ + "static/media/youtube.a745b7310e5b6ca4e61118ee2d6e2d2d.svg";
export { ForwardRef as ReactComponent };